import axios from 'axios'

// DeviceHQ Content-Type header must be set to either application/vnd.api+json or application/json
const TEST_CORS = axios.create({
  baseURL: 'https://jsonplaceholder.typicode.com/',
  headers: {
    'Content-type': 'application/json; charset=UTF-8',
  },
})

const DEVICEHQ_MAKE_SESSION = axios.create({
  baseURL: 'http://localhost:3010',
  headers: {
    'Content-Type': 'application/vnd.api+json',
  },
})

const DEVICEHQ = axios.create({
  baseURL: 'http://localhost:3010',
  headers: {
    'Content-Type': 'application/vnd.api+json',
    'X-AUTH-TOKEN': 'dummyxauthtoken',
  },
})

export {TEST_CORS, DEVICEHQ_MAKE_SESSION, DEVICEHQ}



// WEBPACK FOOTER //
// ./src/devicehq/api/index.js